// Dependencias
import React from 'react';
import './FormPreguntas.css';
import apiEncuesta from '../../../../apiGeneral';
import api from '../../../../api';
import RespuestaSi from '../RespuestaSi/RespuestaSi';

export default class FormPreguntas extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      mostrar: false,
      form: {
        Id_Incidencia: props.RRespuesta?.resultado?.[1]?.[0]?.Id_Incidencia ||
          props.RRespuesta?.resultado?.[0]?.[0]?.Id_Incidencia || "",

        Id_ClienteProveedor: props.RRespuesta?.resultado?.[1]?.[0]?.Id_ClienteProveedor ||
          props.RRespuesta?.resultado?.[0]?.[0]?.Id_ClienteProveedor || "",

        Nro_Contacto: props.RRespuesta?.resultado?.[1]?.[0]?.Nro_Contacto ||
          props.RRespuesta?.resultado?.[0]?.[0]?.Nro_Contacto || "",

        Nom_Contacto: props.RRespuesta?.resultado?.[1]?.[0]?.Nom_Contacto ||
          props.RRespuesta?.resultado?.[0]?.[0]?.Nom_Contacto || "",

        Detalle: props.RRespuesta?.resultado?.[1]?.[0]?.Detalle ||
          props.RRespuesta?.resultado?.[0]?.[0]?.Detalle || "",

        Respuesta: props.RRespuesta?.resultado?.[1]?.[0]?.Respuesta ||
          props.RRespuesta?.resultado?.[0]?.[0]?.Respuesta || "",

        Obs_Incidencia: props.RRespuesta?.resultado?.[1]?.[0]?.Obs_Incidencia ||
          props.RRespuesta?.resultado?.[0]?.[0]?.Obs_Incidencia || "",

        Cod_UsuarioIncidencia: props.RRespuesta?.resultado?.[1]?.[0]?.Cod_UsuarioIncidencia ||
          props.RRespuesta?.resultado?.[0]?.[0]?.Cod_UsuarioIncidencia || "",
        Pregunta1: 0,
        Pregunta2: 0,
        PregDesc1: '',
        PregDesc2: '',
        Pregunta3: '',
        Cod_Estado: '004',
        Cod_UsuarioAct: 'Web',
      },
      data: {
        resultado: []
      },
      consulta: {
        message: undefined
      },


      puntuacion: null,
      comentario: "",
      resuelto: null,

      satisfaccion: null,
      velocidad: null,
      comentario: "",
      cargando: false

    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);


    this.handleRating = this.handleRating.bind(this);


    // Bindeamos los métodos para que el 'this' no se pierda
    this.handleSelection = this.handleSelection.bind(this);
    this.enviarEncuesta = this.enviarEncuesta.bind(this);

  }
  handleChange(e) {
    this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: e.target.value,
      },
    });
    this.setState({ mostrar: false })

  }

  async handleSubmit(e) {
    e.preventDefault();

    try {
      const RIncidencia = this.state.form.Id_Incidencia;
      const RPregunta1 = this.state.form.Pregunta1;
      const RPregunta2 = this.state.form.Pregunta2;
      const RPregunta3 = this.state.form.Pregunta3;
      const RPregDescr1 = this.state.form.PregDesc1;
      const RPregDescr2 = this.state.form.PregDesc2;
      const RCod_Estado = this.state.form.Cod_Estado;
      const RCod_Usuario = this.state.form.Cod_UsuarioAct;


      const data = await api.IncidenciaCliente.guardarIncidencia(RIncidencia, RPregunta1, RPregunta2, RPregunta3, RCod_Estado, RCod_Usuario)

      if (data.Exito === "1") {

        const mensaje = `<h2> Incidencia resuelta </h2>
              <p> </p>
              <div style="text-align: justify;">
                <b>Nro Incidencia:</b> ${RIncidencia} 
              </div>
              <div style="text-align: justify;">
                <b>Satisfacción:</b> ${RPregDescr1} 
              </div>
              <div style="text-align: justify;">
                <b>Velocidad:</b> ${RPregDescr2} 
              </div>
              <div style="text-align: justify;">
                <b>Comentario:</b>  
                <p>${RPregunta3}</p>
              </div>
             `

        const emailEncuesta = await api.usuario.enviarCorreoEncuesta(RIncidencia, mensaje);

        if (emailEncuesta.Exito == "1") {
          alert("Mensaje enviado !")
          window.location.href = '/';
        }
        else {
          alert("no se pudo enviar el mensaje")
          window.location.href = '/';
        }
      }

      this.setState({
        consulta: { message: [].concat(this.state.data, data.message) },
        data: { resultado: [].concat(this.state.data, data.resultado) }, mostrar: true
      });

    } catch (error) {
      console.log('Error', error)
      alert('revise los datos porfavor hubo un error');
      this.setState({ mostrar: false });

    }

  }

  handleRating(val) {
    this.setState({ puntuacion: val });
  }

  handleSelection(pregunta, valor) {
    this.setState({
      form: {
        ...this.state.form,
        [pregunta]: valor,
      },
    });

  }

  handleSelection2(pregunta, valor) {
    this.setState((prevState) => ({
      form: {
        ...prevState.form,       // Mantiene absolutamente TODA la data del formulario anterior
        [pregunta]: valor,       // Guarda el valor del botón seleccionado
      }
    }));
  }

  enviarEncuesta() {
    console.log("Enviando datos de la jefa:", this.state);
    // Aquí iría tu fetch a la API dinámico que armamos antes
  }


  render() {
    const nivelesSat = [
      { v: 1, t: "Muy Malo", i: "fa-face-angry", c: "#D32F2F" },
      { v: 2, t: "Malo", i: "fa-face-frown", c: "#F57C00" },
      { v: 3, t: "Regular", i: "fa-face-meh", c: "#FBC02D" },
      { v: 4, t: "Bueno", i: "fa-face-smile", c: "#388E3C" },
      { v: 5, t: "Muy Bueno", i: "fa-face-laugh-beam", c: "#1B5E20" }
    ];

    const nivelesVel = [
      { v: 1, t: "Muy Lento", i: "fa-gauge-simple", r: 270, c: "#D32F2F" }, // 270° (Apunta abajo/izquierda)
      { v: 2, t: "Lento", i: "fa-gauge-simple", r: 315, c: "#F57C00" },     // ¡315° Exactos! (Apunta diagonal izquierda)
      { v: 3, t: "Regular", i: "fa-gauge-simple", r: 0, c: "#FBC02D" },       // 0° (Al medio / estándar)
      { v: 4, t: "Rápido", i: "fa-gauge-high", r: 0, c: "#388E3C" },         // Icono nativo rápido
      { v: 5, t: "Muy Rápido", i: "fa-bolt", r: 0, c: "#1B5E20" }             // El rayo
    ];
    return (

      <div className="FormPreguntas">
        <div className="FormPreguntas__bloque1">
          <form onSubmit={this.props.onSubmit} >
            <div > {/* aqui codigo antiguo */}

              {/* Pregunta 1 */}
              <div className="pregunta-block">
                <p><b>1. ¿Cómo calificaría la atención recibida?</b></p>
                <div className="pills-wrapper">
                  {nivelesSat.map((item) => (
                    <button
                      key={item.v}
                      type="button"
                      className={`pill-button ${this.state.satisfaccion === item.v ? 'active' : ''}`}
                      style={{
                        color: this.state.form.Pregunta1 === item.v ? 'white' : item.c,
                        background: this.state.form.Pregunta1 === item.v ? item.c : 'white',
                        border: `1px solid ${item.c}`
                      }}
                      onClick={() => {
                        this.handleSelection('Pregunta1', item.v)
                        this.handleSelection2('PregDesc1', item.t)
                      }}
                    >
                      <i className={`fa-solid ${item.i}`}></i>
                      <span>{item.t}</span>
                    </button>
                  ))}
                </div>
              </div>

              {/* Pregunta 2 */}
              <div className="pregunta-block">
                <p><b>2. ¿Cómo calificaría la velocidad de respuesta?</b></p>
                <div className="pills-wrapper">
                  {nivelesVel.map((item) => (
                    <button
                      key={item.v}
                      type="button"
                      className={`pill-button ${this.state.velocidad === item.v ? 'active' : ''}`}
                      style={{
                        color: this.state.form.Pregunta2 === item.v ? 'white' : item.c,
                        background: this.state.form.Pregunta2 === item.v ? item.c : 'white',
                        border: `1px solid ${item.c}`
                      }}
                      onClick={() => {
                        this.handleSelection('Pregunta2', item.v)
                        this.handleSelection2('PregDesc2', item.t)
                      }}
                    >
                      <i
                        className={`fa-solid ${item.i}`}
                        style={{
                          transform: `rotate(${item.r}deg)`,
                          display: 'inline-block', // Obligatorio para que los iconos puedan rotar en CSS
                          transition: 'transform 0.3s ease' // Detalle premium: ¡La aguja girará con animación al cambiar de color!
                        }}
                      ></i>
                      <span>{item.t}</span>
                    </button>
                  ))}
                </div>
              </div>

              {/* Pregunta 3 */}
              <div className="pregunta-block">
                <p><b>3. Dejanos un comentario</b></p>
                <div className="pills-wrapper">
                  <textarea name="Pregunta3" value={this.state.form.Pregunta3 || ''} onChange={this.handleChange}></textarea>
                </div>
              </div>
            </div>

          </form>

          <div className="pregunta-block-submit-container">
            <button
              type="submit"
              onClick={this.handleSubmit}
            >
              Enviar Encuesta
            </button>
          </div>
        </div>
      </div>
    )
  }

}
